import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es un producto físico?',
    a: 'No. Es un producto 100% digital para descargar e imprimir.'
  }, {
    q: '¿Lo recibo al momento?',
    a: 'Sí. Una vez confirmada la compra accedés a la descarga.'
  }, {
    q: '¿Cuántas veces puedo imprimirlo?',
    a: 'Las veces que quieras para uso personal.'
  }, {
    q: '¿Necesito una impresora especial?',
    a: 'No. Podés imprimirlo en casa o en cualquier gráfica.'
  }, {
    q: '¿Sirve para marcadores acrílicos?',
    a: 'Sí, siempre que uses un papel adecuado.'
  }, {
    q: '¿Los archivos se imprimen bien?',
    a: 'Sí. Los PDFs están preparados en buena calidad para que se vean nítidos al imprimirlos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-10 md:py-14 px-4 bg-[#FFFAF7]" data-id="element-34" data-mp="1vqszc3cyt7m2">
      <div className="max-w-3xl mx-auto" data-id="element-35" data-mp="1ro63zsh354k4">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-36" data-mp="1rp7he3lkq350">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D2D3F]" data-id="element-37" data-mp="20n17uxwnq2k9">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-38" data-mp="2advva5ln387a">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="border border-gray-200 rounded-xl sm:rounded-2xl overflow-hidden bg-white shadow-sm" data-id="element-39" data-mp="2oeyhcicmwii7" data-mpi={index}>
              <button onClick={() => toggleFAQ(index)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors" data-id="element-40" data-mp="2p3tzeimk1uq1">
                <span className="font-bold text-[#2D2D3F] pr-4 text-sm sm:text-base" data-id="element-41" data-mp="2u2x585ad04z2">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#FF6B8A] shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" data-mp="3333gdkil4sv2" />
              </button>
              <AnimatePresence data-id="element-43" data-mp="380lq3d4ffc44">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44" data-mp="3d084vqzwl0f1">
                    <div className="px-5 pb-4 pt-1 text-[#6B7280] text-sm sm:text-base border-t border-gray-50" data-id="element-45" data-mp="3quqzhg9luzms">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}